var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataMobile(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4H9.83333M0.5 4V9.13333C0.5 9.78667 0.5 10.1133 0.627167 10.363C0.739017 10.5825 0.917487 10.761 1.137 10.8728C1.38608 11 1.71275 11 2.36492 11H7.96842C8.62058 11 8.94667 11 9.19575 10.8728C9.41567 10.7608 9.59417 10.5823 9.70617 10.363C9.83333 10.1133 9.83333 9.78783 9.83333 9.13567V4M0.5 4V3.53333C0.5 2.88 0.5 2.55333 0.627167 2.30367C0.739167 2.08375 0.917083 1.90583 1.137 1.79383C1.38667 1.66667 1.71333 1.66667 2.36667 1.66667H2.83333M9.83333 4V3.53158C9.83333 2.87942 9.83333 2.55275 9.70617 2.30367C9.59416 2.08407 9.41548 1.90558 9.19575 1.79383C8.94667 1.66667 8.62 1.66667 7.96667 1.66667H7.5M2.83333 1.66667H7.5M2.83333 1.66667V0.5M7.5 1.66667V0.5",
    stroke: "#9399A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataMobile);
export default __webpack_public_path__ + "static/media/dataMobile.86798c1e28d1a97d4f415798b3516f2e.svg";
export { ForwardRef as ReactComponent };